import React, {useEffect, useRef, useState} from 'react';
import '../../assets/scss/v1/RecordPlayer.scss';
import musicCdGif from "../../assets/images/v1/wedding-card/music_player.gif"
import musicCdPng from "../../assets/images/v1/wedding-card/music_player_1.png"

const RecordPlayer = () => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [musicDisc, setMusicDisc] = useState(musicCdGif);

    const togglePlay = () => {
        if (isPlaying) {
            audioRef.current.pause();
            setMusicDisc(musicCdPng);
        } else {
            audioRef.current.play();
            setMusicDisc(musicCdGif);
        }
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (isPlaying) {
            setMusicDisc(musicCdGif);
        } else {
            setMusicDisc(musicCdPng);
        }
    }, [isPlaying]);

    return (
        <div className="recordSection">
            <img
                src={musicDisc}
                alt="Record"
                // className={`record ${isPlaying ? 'spin' : ''}`}
                onClick={togglePlay}
                style={{ width: '75px', height:'auto',cursor: 'pointer' }}
            />
            <audio ref={audioRef} src="https://khan-web-prod.s3.ap-southeast-1.amazonaws.com/static/audio/ido_ducphuc911.mp3" />
        </div>
    );
};

export default RecordPlayer;